export default "__VITE_ASSET__bc981038__"